import SignableLetter from './SignableLetter.js';

export default class ChildLetter {

    static fromData(data) {
        let letter = new ChildLetter();
        letter.id = data.id;
        letter.child = data.child;
        letter.hasSignatures = data.hasSignatures;
        letter.title = data.title
        letter.created = new Date(data.createdAt);
        letter.updated = new Date(data.updatedAt);
        letter.referenceDate = new Date(data.referenceDate);
        letter.clearing = data.clearing;
        letter.isInternal = data.isInternal;
        letter.isEmailable = data.isEmailable;
        letter.sent = data.sent ? new Date(data.sent) : null;
        letter.sentBy = data.sentBy;
        letter.inExchangeDirectory = data.inExchangeDirectory;
        letter.signableLetter = data.signableLetter;

        return letter;
    }

    getSignableLetter() {
        if(!this.signableLetter) {
            return null;
        }

        const data = {
            ...this.signableLetter,
            id: this.id,
            title: this.title,
            child: this.child,
            isEmailable: this.isEmailable,
            createdAt: this.created,
            updatedAt: this.updated,
            referenceDate: this.referenceDate,
        };

        return SignableLetter.fromData(data)
    }
}
